(function () {
  function openShopSubmenu(e) {
    const link = e.target.closest("a.mobile-nav__link");
    if (!link) return;

    // Only when this link is inside a dropdown parent
    const group = link.closest(".mobile-nav--has-sublist");
    if (!group) return;

    // Only for the SHOP item
    const label = (link.textContent || "").trim().toLowerCase();
    if (label !== "shop") return;

    // If already expanded, allow normal link behaviour (optional)
    // If you NEVER want Shop to navigate, delete the next 2 lines.
    if (group.classList.contains("mobile-nav--expanded")) return;

    // Stop navigation + stop theme handlers
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    // Click the same button the arrow uses
    const btn = group.querySelector("button.mobile-nav__toggle-open, button.mobile-nav__toggle-close");
    if (btn) btn.click();
  }

  // Mobile browsers can fire touch before click - catch both
  document.addEventListener("touchend", openShopSubmenu, true);
  document.addEventListener("click", openShopSubmenu, true);
})();
// UNLTD - add product/page/collection handle as a body class for CSS targeting
(function() {
  const path = window.location.pathname;
  const parts = path.split('/').filter(Boolean);
  if (parts.length < 2) return;
  const handle = parts[parts.length - 1].split('?')[0];
  const type = parts[0]; // 'products', 'pages', 'collections', etc.
  if (!handle || !type) return;
  // Strip trailing 's' to give 'product-', 'page-', 'collection-'
  const prefix = type.endsWith('s') ? type.slice(0, -1) : type;
  document.body.classList.add(prefix + '-' + handle);
})();
// UNLTD - animate the hero counter on scroll into view
(function() {
  const counter = document.querySelector('.hp-counter .num');
  if (!counter) return;
  const target = parseInt(counter.getAttribute('data-target')) || 500;
  let started = false;
  const animate = () => {
    if (started) return;
    started = true;
    const duration = 1800;
    const start = performance.now();
    const tick = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = Math.floor(target * eased);
      counter.firstChild.textContent = value.toLocaleString();
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };
  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) animate();
  }, { threshold: 0.5 });
  observer.observe(counter);
})();
// ===================================================================
// UNLTD. - Auto-add bottle opener welcome gift (v2 - aggressive)
// Intercepts fetch/XHR for instant detection + intercepts checkout
// ===================================================================
(function() {
  const BOTTLE_OPENER_VARIANT_ID = 56333678575994;
  let isProcessing = false;

  async function syncWelcomeGift() {
    if (isProcessing) return false;
    isProcessing = true;
    let changed = false;

    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const hasSubscription = cart.items.some(item => item.selling_plan_allocation != null);
      const giftLine = cart.items.find(item => item.variant_id === BOTTLE_OPENER_VARIANT_ID);

      // ADD if subscription present + no gift
      if (hasSubscription && !giftLine) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: BOTTLE_OPENER_VARIANT_ID,
              quantity: 1,
              properties: { '_welcome_gift': 'true', 'Free gift': 'Welcome to UNLTD.' }
            }]
          })
        });
        changed = true;
      }

      // REMOVE if no subscription + gift was auto-added
      if (!hasSubscription && giftLine && giftLine.properties && giftLine.properties._welcome_gift === 'true') {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: giftLine.key, quantity: 0 })
        });
        changed = true;
      }

      // LOCK quantity to 1
      if (giftLine && giftLine.quantity > 1) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: giftLine.key, quantity: 1 })
        });
        changed = true;
      }
    } catch (e) {
      console.error('UNLTD gift sync error:', e);
    } finally {
      isProcessing = false;
    }

    if (changed) {
      // Dispatch every common event to refresh cart drawer UI
      ['cart:refresh', 'cart:updated', 'cart:change', 'cart:build'].forEach(evt => {
        document.dispatchEvent(new CustomEvent(evt));
        window.dispatchEvent(new CustomEvent(evt));
      });
      // Try to trigger Flow 41 cart drawer reload
      if (window.theme && window.theme.cart && window.theme.cart.getCart) {
        try { window.theme.cart.getCart(); } catch (e) {}
      }
      // Hard reload if on cart page
      if (window.location.pathname === '/cart') {
        window.location.reload();
      }
    }

    return changed;
  }

  // ----- INTERCEPT FETCH -----
  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    const response = await originalFetch.apply(this, args);
    if (url && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
      if (!isProcessing) {
        setTimeout(syncWelcomeGift, 200);
      }
    }
    return response;
  };

  // ----- INTERCEPT XHR -----
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._cartUrl = url;
    return originalXHROpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function() {
    if (this._cartUrl && (this._cartUrl.includes('/cart/add') || this._cartUrl.includes('/cart/change') || this._cartUrl.includes('/cart/update'))) {
      this.addEventListener('load', function() {
        if (!isProcessing) {
          setTimeout(syncWelcomeGift, 200);
        }
      });
    }
    return originalXHRSend.apply(this, arguments);
  };

  // ----- INTERCEPT CHECKOUT BUTTON -----
  document.addEventListener('click', async function(e) {
    const target = e.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [data-checkout-button], .checkout-button, .cart__checkout');
    if (target) {
      e.preventDefault();
      e.stopImmediatePropagation();
      await syncWelcomeGift();
      window.location.href = '/checkout';
    }
  }, true); // capture phase - fires BEFORE other handlers

  // ----- INITIAL LOAD -----
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncWelcomeGift);
  } else {
    syncWelcomeGift();
  }

  // ----- SAFETY POLL on cart/checkout pages -----
  if (window.location.pathname === '/cart' || window.location.pathname.includes('/checkout')) {
    setInterval(syncWelcomeGift, 3000);
  }
})();